export default __webpack_public_path__ + "static/media/nft21.a15a7521.png";